import { useSelector } from 'react-redux';

/**
 * This is the projects page selector. For firestore bound data,
 * check out `useMyProjects`
 */
export const useProjectsState = () => useSelector((state) => state.projects);
